import { Modal } from "react-bootstrap";
import React from "react";
import {Button, Grid} from '@material-ui/core';

const CustomModal = (props) => {
    const { open, handleClose, buttonsArray, onClick } = props;

    return (
      <Modal
        show={open}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
          <Modal.Header closeButton />
          <Modal.Body style={{background: 'rgba(255, 255, 255, 0.5)', padding: '2rem'}}>
              <h1>Watch recorded sessions</h1>
              <br/>
              <Grid container direction='row'>
                  {buttonsArray.map((element) => (
                    <Grid item md={12} lg={2} style={{textAlign: 'center'}}>
                        <Button variant="contained"
                                onClick={() => { onClick(element.Video) }}
                                color="primary"
                                disableElevation>{element.title}</Button>
                    </Grid>
                  ))}
              </Grid>
          </Modal.Body>
      </Modal>
    );
};
export default CustomModal;
